// Web module: assets (people lane). Assets inventory at Drata parity (filters, owner status, device compliance, bulk
// create/update import, CSV). Detail stays on the generic page. The contract is in ../README.md.
import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const module: WebModule = {
  routes: [],
  entityOverrides: {
    asset: {
      ListPage: lazyComponent(() => import('./AssetsListPage'), 'AssetsListPage'),
    },
  },
}
